/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, arrayOf, string, array, number, func,
} from 'prop-types';
import DesktopMobile from '../../../../../../../helpers/DesktopMobile/DesktopMobile';
import DesktopTabletImoc from './Partials/DesktopTabletImoc/DesktopTabletImoc';
import MobileImoc from './Partials/MobileImoc/MobileImoc';
import { getLanguageName } from '../../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import PlantsMobileImoc from './Partials/MobileImoc/PlantsMobileImoc';
import PlantsDesktopTabletImoc from './Partials/DesktopTabletImoc/PlantsDesktopTabletImoc';

/*
    If viewport is add in any one of IMOC, only that IMOC will be displayed on the selected viewport
    If no viewport is selected on any IMOC, last imoc will be displayed on both desktop and mobile (backward compatibility)
*/

const GraphqlImoc = ({
    imocBlock, brand, samedayCutoff, totalCount, ssrDeviceType, featureFlags, setFacetsOptions, setFilterOptions, presentation_family, productFacets, imocHeightHandler,
}) => {
    const { imoc_group = [] } = imocBlock;
    // initially assign value to both mobile and desktop (backward compatibility)
    let mobileBlock = imoc_group;
    let desktopBlock = imoc_group;
    const language = getLanguageName();

    // check if viewport is added to any one of IMOC block. Assign that imoc block or assign null if no viewport is selected
    if (imoc_group?.some((block) => block?.viewport?.length)) {
        mobileBlock = imoc_group.filter((block) => block.viewport[0]?.select?.includes('Mobile')) || null;
        desktopBlock = imoc_group.filter((block) => block.viewport[0]?.select?.includes('Desktop')) || null;
    }
    const renderImocUI = () => {
        switch (brand) {
            case 'plants':
                return (
                    <DesktopMobile
                        mobile={() => <PlantsMobileImoc imocBlock={mobileBlock} samedayCutoff={samedayCutoff} totalCount={totalCount} ssrDeviceType={ssrDeviceType} featureFlags={featureFlags} setFacetsOptions={setFacetsOptions} setFilterOptions={setFilterOptions} presentation_family={presentation_family} brand={brand} productFacets={productFacets} imocHeightHandler={imocHeightHandler} language={language} />}
                        desktop={() => <PlantsDesktopTabletImoc imocBlock={desktopBlock} brand={brand} samedayCutoff={samedayCutoff} imocHeightHandler={imocHeightHandler} />}
                        breakpoint={600}
                        ignoreHover
                    />
                );
            case 'canada':
                return (
                    <DesktopMobile
                        mobile={() => <MobileImoc imocBlock={mobileBlock} samedayCutoff={samedayCutoff} totalCount={totalCount} ssrDeviceType={ssrDeviceType} featureFlags={featureFlags} setFacetsOptions={setFacetsOptions} setFilterOptions={setFilterOptions} presentation_family={presentation_family} brand={brand} productFacets={productFacets} imocHeightHandler={imocHeightHandler} language={language} />}
                        desktop={() => <DesktopTabletImoc imocBlock={desktopBlock} brand={brand} samedayCutoff={samedayCutoff} imocHeightHandler={imocHeightHandler} />}
                        breakpoint={600}
                        ignoreHover
                    />
                );
            default:
                return null;
        }
    };
    return (
        <>
            { renderImocUI() }
        </>
    );
};

GraphqlImoc.propTypes = {
    imocBlock: shape({
        imoc_group: arrayOf(
            shape({
                layout: string,
                header: string.isRequired,
                copy: string.isRequired,
                read_more_copy: string,
                image: object,
                offer_section: object,
            }),
        ).isRequired,
    }).isRequired,
    brand: string.isRequired,
    samedayCutoff: shape({
        entries: arrayOf(shape({
            cutoff_entries: array,
        })),
    }),
    totalCount: number.isRequired,
    ssrDeviceType: string.isRequired,
    featureFlags: object.isRequired,
    setFacetsOptions: func.isRequired,
    setFilterOptions: func.isRequired,
    presentation_family: string.isRequired,
    imocHeightHandler: func,
    productFacets: arrayOf(
        shape({
            name: string.isRequired,
            entries: arrayOf(
                shape({
                    name: string.isRequired,
                    value: string.isRequired,
                }),
            ).isRequired,
        }).isRequired,
    ).isRequired,
};

GraphqlImoc.defaultProps = {
    samedayCutoff: {},
    imocHeightHandler: null,
};

export default GraphqlImoc;
